import DAO from "../DAO/DAO";
import { setPermissions } from "../middlewares/permissions_control/permissions";
import Empresa from "./Empresa";
import Usuario from "./Usuario";
import Perfil from "./Perfil";

export default class Colaborador {
	pk;
	empresa;
	perfil;
	permissoes;

	constructor({
		pk,
		empresa,
		perfil,
		permissoes
	}) {
		this.pk = pk;
		this.empresa = empresa;
		this.perfil = perfil ? Perfil.fromMap(perfil) : perfil;
		this.permissoes = permissoes;
	}

	static get quantidadeColaboradores() {
		return Colaborador.getColaboradores().length;
	}

	static getColaboradores() {
		return DAO.colaborador.getAll();
	}

	static getColaborador() {
		const colaboradorData = DAO.colaborador.get();
		if (!colaboradorData) return null;
		// Garantir que o perfil seja mapeado mesmo se vier do DAO
		const colaborador = new Colaborador(colaboradorData);
		return colaborador;
	}

	static setColaborador(colaborador) {
		colaborador = new Colaborador(colaborador);

		DAO.colaborador.set(colaborador);
		Empresa.setEmpresa(colaborador.empresa);
		setPermissions(colaborador.permissoes);
	}

	static setColaboradorPorEmpresa(empresa) {
		const usuarioAutenticado = Usuario.getUsuarioAutenticado();
		const colaboradores = Colaborador.getColaboradores();
		const colaborador = colaboradores.find(colaborador => {
			if (!colaborador || !colaborador.empresa) return false;
			return empresa.pk == colaborador.empresa.pk
		});

		if (colaborador) {
			DAO.colaborador.set(colaborador);
			if (usuarioAutenticado.isSuperUser) {
				colaborador.permissoes["autenticado"] = {
					superuser: true
				}
			} else {
				colaborador.permissoes["autenticado"] = {
					autenticado: true
				}
			}

			setPermissions(colaborador.permissoes);

		} else {
			throw Error("Colaborador não encontrado");
		}
	}

	static removerColaborador() {
		DAO.colaborador.set(null);
	}

	static hasColaborador() {
		const colaborador = Colaborador.getColaborador();

		if (!colaborador || !colaborador.pk) {
			return false;
		}

		return true;
	}
}
